import type { SVGProps } from "react";

export function IconBlackUmbrella(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="none"
      {...props}
    >
      <path
        d="M12 37C12 37.7879 12.1552 38.5681 12.4567 39.2961C12.7583 40.0241 13.2002 40.6855 13.7574 41.2426C14.3145 41.7998 14.9759 42.2417 15.7039 42.5433C16.4319 42.8448 17.2121 43 18 43C18.7879 43 19.5681 42.8448 20.2961 42.5433C21.0241 42.2417 21.6855 41.7998 22.2426 41.2426C22.7998 40.6855 23.2417 40.0241 23.5433 39.2961C23.8448 38.5681 24 37.7879 24 37L24 24.75"
        stroke="#23232C"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2418 5.62673C11.6875 7.36714 5.25 14.9318 5.25 24V24.75H31.25V24C31.25 18.8973 30.4167 14.0395 28.963 10.4961C28.2361 8.72424 27.3991 7.39099 26.5286 6.51213C25.6605 5.63563 24.802 5.25 24 5.25C23.198 5.25 22.3395 5.63563 21.4714 6.51213C20.6009 7.39099 19.7639 8.72424 19.037 10.4961C17.5833 14.0395 16.75 18.8973 16.75 24V24.75H15.25V24C15.25 18.7593 16.1024 13.6972 17.6493 9.92675C18.3823 8.14004 19.2565 6.67912 20.2418 5.62673ZM27.7582 5.62673C28.7435 6.67912 29.6177 8.14004 30.3507 9.92675C31.8976 13.6972 32.75 18.7593 32.75 24V24.75H42.75V24C42.75 14.9318 36.3125 7.36714 27.7582 5.62673Z"
        fill="#23232C"
      />
      <path
        d="M24 6V3.5"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
